import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "v-tasks" }
const _hoisted_2 = { class: "v-tasks__header" }
const _hoisted_3 = { class: "v-tasks__body" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "v-tasks__date-label" }
const _hoisted_6 = ["value", "name"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "company__name" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = {
  key: 0,
  class: "note__icon"
}
const _hoisted_11 = { class: "app" }
const _hoisted_12 = { class: "v-users__badge driver__name" }
const _hoisted_13 = {
  key: 0,
  class: "note__icon"
}
const _hoisted_14 = { class: "v-users__badge" }
const _hoisted_15 = {
  key: 0,
  class: "custom__user--info"
}
const _hoisted_16 = { class: "title" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "custom__problem"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "custom__problem--info"
}
const _hoisted_23 = { class: "title" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 1,
  class: "custom__problem"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "icon"
}
const _hoisted_29 = { class: "td__dropdown" }
const _hoisted_30 = { class: "td__dropdown" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "td__dropdown" }
const _hoisted_33 = { class: "problem__group" }
const _hoisted_34 = {
  key: 0,
  class: "v-tasks__loading-more"
}
const _hoisted_35 = {
  key: 1,
  class: "v-tasks__end"
}
const _hoisted_36 = { class: "new-modal" }
const _hoisted_37 = { class: "description__footer" }
const _hoisted_38 = { class: "new-modal" }
const _hoisted_39 = { class: "auto-complete" }
const _hoisted_40 = { class: "description__footer" }
const _hoisted_41 = { class: "task-modal" }
const _hoisted_42 = { class: "history" }
const _hoisted_43 = {
  key: 0,
  class: "change"
}
const _hoisted_44 = { class: "badge" }
const _hoisted_45 = { class: "icon" }
const _hoisted_46 = { class: "badge" }
const _hoisted_47 = { class: "change" }
const _hoisted_48 = { class: "icon" }
const _hoisted_49 = { class: "comment" }
const _hoisted_50 = { class: "body" }
const _hoisted_51 = { class: "body__list" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "item__time" }
const _hoisted_54 = { class: "item__body" }
const _hoisted_55 = { class: "item__body--user" }
const _hoisted_56 = { class: "item__body--text" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "body__footer" }
const _hoisted_59 = {
  key: 0,
  class: "rest-info"
}
const _hoisted_60 = { class: "headline" }
const _hoisted_61 = { class: "body" }
const _hoisted_62 = {
  key: 0,
  class: "rest"
}
const _hoisted_63 = { class: "rest__headline" }
const _hoisted_64 = { class: "caption" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "rest__time" }
const _hoisted_67 = { class: "duration" }
const _hoisted_68 = { class: "value" }
const _hoisted_69 = { class: "from" }
const _hoisted_70 = { class: "value" }
const _hoisted_71 = { class: "to" }
const _hoisted_72 = { class: "value" }
const _hoisted_73 = { class: "rest__location" }
const _hoisted_74 = { class: "location" }
const _hoisted_75 = { class: "value" }
const _hoisted_76 = { class: "status" }
const _hoisted_77 = { class: "value" }
const _hoisted_78 = { key: 1 }

import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import {
  ArrowNarrowRight,
  ChevronDown,
  Copy06,
  InfoCircle,
  LinkExternal02,
  Pencil02,
  SearchMd,
  Send03,
  X,
  Check,
} from "utruckin-icons";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import CommonStatus from "@/components/common/CommonStatus.vue";
import { useTaskStore } from "@/features/tasks/task.store";
import { useTeamStore } from "@/features/teams/team.store";
import { useWorkTypeStore } from "@/features/work-types/work-type.store";
import { INewTask, ITaskData } from "@/features/tasks/task.types";
import { ITeam } from "@/features/teams/team.types";
import { IWorkType } from "@/features/work-types/work-type.types";
import { TaskStatus } from "@/features/tasks/task.enum";
import { DateTime } from "luxon";
import CustomTableDropdown from "@/components/custom/CustomTableDropdown.vue";
import TaskAdditionalWorkTypes from "@/components/custom/TaskAdditionalWorkTypes.vue";
import { taskService } from "@/features/tasks/task.service";
import { useCompanyStore } from "@/features/company/company.store";
import { ICompany } from "@/features/company/company.types";
import { useUserStore } from "@/features/users/user.store";
import { useDriverStore } from "@/features/drivers/drivers.store";
import { IDriver } from "@/features/drivers/drivers.types";
import { useNotification } from "@/utils/notification";
import { useAppStore } from "@/store/app.store";
import { IDropdown } from "@/types/main";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonModal from "@/components/common/CommonModal.vue";
import { useArchiveStore } from "@/features/archive/archive.store";
import CommonInput from "@/components/common/CommonInput.vue";
import { IUser } from "@/features/users/user.types";
import CustomStatusBadge from "@/components/custom/CustomStatusBadge.vue";
import CustomSearchDropdown from "@/components/custom/CustomSearchDropdown.vue";
import { onBeforeMount } from "vue";
import { useCheckStore } from "@/features/check/check.store";
import router from "@/router";
import { companyService } from "@/features/company/company.service";
import { driverService } from "@/features/drivers/drivers.service";
import { workTypeService } from "@/features/work-types/work-type.service";

const PAGE_SIZE = 50;

export default /*@__PURE__*/_defineComponent({
  __name: 'AllTasksView',
  setup(__props) {

const taskStore = useTaskStore();
const teamStore = useTeamStore();
const workTypeStore = useWorkTypeStore();
const companyStore = useCompanyStore();
const usersStore = useUserStore();
const driverStore = useDriverStore();
const appStore = useAppStore();
const archiveStore = useArchiveStore();
const checkStore = useCheckStore();
const { pushNotification } = useNotification();

const tasks = ref<ITaskData[]>([]);
const teams = ref<ITeam[]>([]);
const users = ref<IUser[]>([]);
const companies = ref<ICompany[]>([]);
const workTypes = ref<IWorkType[]>([]);
const drivers = ref<IDriver[]>([]);
const problems = ref<IWorkType[]>([]);

const tasksLoading = ref(false);
const teamLoading = ref(false);
const userLoading = ref(false);
const workTypeLoading = ref(false);
const companyLoading = ref(false);
const driverLoading = ref(false);

const team = ref<string>("");
const user = ref<string>("");
const status = ref<string>("");
const problem = ref<string>("");
const search = ref<string>("");
const isAdmin = ref<boolean>(false);
const newTaskStatus = ref<string>("new");
const description = ref<string>("");
const newModal = ref(false);

const taskModal = ref<boolean>(false);
const taskModalItem = ref<any>();
const taskModalLoading = ref<boolean>(false);
const taskModalComment = ref<string>("");

const archiveModal = ref(false);
const archiveReason = ref<string>("");
const archiveModalItem = ref<ITaskData | null>(null);
const isSaving = ref<boolean>(false);

let searchTimer: ReturnType<typeof setTimeout> | null = null;
let searchCompanyTimer: ReturnType<typeof setTimeout> | null = null;
let searchDriverTimer: ReturnType<typeof setTimeout> | null = null;
let searchProblemTimer: ReturnType<typeof setTimeout> | null = null;
let searchFilterProblemTimer: ReturnType<typeof setTimeout> | null = null;
let searchFilterUserTimer: ReturnType<typeof setTimeout> | null = null;

const collapsedDates = ref<Record<string, boolean>>({});
const collapsedShifts = ref<Record<string, boolean>>({});

const dropdown1 = ref();
const dropdown2 = ref();
const dropdown3 = ref();

const page = ref(1);
const hasMore = ref(true);
const isLoadingMore = ref(false);
const scrollContainer = ref<HTMLElement | null>(null);
const sentinel = ref<HTMLElement | null>(null);
let observer: IntersectionObserver | null = null;

const STATUS_COLORS: Record<TaskStatus, string> = {
  [TaskStatus.NEW]: "--color-system-blue",
  [TaskStatus.INFORM]: "--color-system-grey",
  [TaskStatus.IN_PROGRESS]: "--color-system-orange",
  [TaskStatus.ON_HOLD]: "--color-system-yellow",
  [TaskStatus.DONE]: "--color-system-green",
  [TaskStatus.QA_FAILED]: "--color-system-red",
  [TaskStatus.CLOSED]: "--color-system-green",
};

const newTask = ref<INewTask>({
  company_id: "",
  driver_id: "",
  work_type_id: "",
  priority: "",
  assignee_id: "",
});

const companyItems = computed(() =>
  (companies.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
    app: c.provider_name,
  }))
);

const driverItems = computed(() =>
  (drivers.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
    app: c.truck_number,
  }))
);

const problemItems = computed(() =>
  (problems.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
    app: String(c.base_points),
  }))
);

const problemFilterItems = computed(() =>
  (workTypes.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
  }))
);

const userFilterItems = computed(() =>
  (users.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
  }))
);

const filteredItems = computed(() => {
  if (taskStore.commonFilter.team_id) {
    return [
      {
        name: "id",
        label: "No",
        width: "3%",
      },
      {
        name: "company",
        label: "Company",
        width: "14%",
      },
      {
        name: "drivers",
        label: "Drivers",
        width: "14%",
      },
      {
        name: "users",
        label: "User",
        width: "13%",
      },
      {
        name: "date",
        label: "Start time",
        width: "6%",
      },
      {
        name: "completed_time",
        label: "End time",
        width: "6%",
      },
      {
        name: "points_awarded",
        label: "KPI",
        width: "3%",
      },
      {
        name: "status",
        label: "Status",
        width: "9%",
      },
      {
        name: "problems",
        label: "Problems",
        width: "29%",
      },
      {
        name: "actions",
        label: "",
        width: "3%",
      },
    ];
  } else {
    return [
      {
        name: "id",
        label: "No",
        width: "3%",
      },
      {
        name: "company",
        label: "Company",
        width: "14%",
      },
      {
        name: "drivers",
        label: "Drivers",
        width: "14%",
      },
      {
        name: "team",
        label: "Team",
        width: "5%",
      },
      {
        name: "users",
        label: "User",
        width: "13%",
      },
      {
        name: "date",
        label: "Start time",
        width: "6%",
      },
      {
        name: "completed_time",
        label: "End time",
        width: "6%",
      },
      {
        name: "points_awarded",
        label: "KPI",
        width: "3%",
      },
      {
        name: "status",
        label: "Status",
        width: "9%",
      },
      {
        name: "problems",
        label: "Problems",
        width: "24%",
      },
      {
        name: "actions",
        label: "",
        width: "3%",
      },
    ];
  }
});

const hasUserHasAction = (item: ITaskData) => {
  return (
    usersStore.userProfile &&
    (usersStore.userProfile.id == item.assignee_id ||
      usersStore.userProfile.role == "admin" ||
      usersStore.userProfile.role == "super_admin" ||
      usersStore.userProfile.role == "supervisor")
  );
};

const formatStatusLabel = (key: string) =>
  key.replace(/_/g, "_").replace(/\b\w/g, (c) => c.toUpperCase());

const statusItems = (
  Object.keys(TaskStatus) as Array<keyof typeof TaskStatus>
).map((key) => ({
  value: TaskStatus[key],
  name: formatStatusLabel(key),
  color: STATUS_COLORS[TaskStatus[key]],
}));

const getStatus = (qaStatus: string) => {
  const key = (Object.keys(TaskStatus) as Array<keyof typeof TaskStatus>).find(
    (k) => TaskStatus[k] === qaStatus
  );
  return key ? formatStatusLabel(key) : null;
};

const toggleDate = (date: string) => {
  collapsedDates.value[date] = !collapsedDates.value[date];
};

const toggleShift = (date: string, shift: string) => {
  const key = `${date}::${shift}`;
  collapsedShifts.value[key] = !collapsedShifts.value[key];
};

const isDateCollapsed = (date: string) => collapsedDates.value[date];
const isShiftCollapsed = (date: string, shift: string) =>
  collapsedShifts.value[`${date}::${shift}`];

const groupedByDate = computed(() => {
  const dateMap = new Map<string, Map<string, ITaskData[]>>();

  for (const task of tasks.value) {
    const date = task.created_time
      ? DateTime.fromISO(task.created_time, { zone: "utc" })
          .setZone("America/New_York")
          .toFormat("yyyy-MM-dd")
      : "Unknown";

    const shift = task.shift_name ?? "Unknown Shift";

    if (!dateMap.has(date)) {
      dateMap.set(date, new Map());
    }

    const shiftMap = dateMap.get(date)!;

    if (!shiftMap.has(shift)) {
      shiftMap.set(shift, []);
    }

    shiftMap.get(shift)!.push(task);
  }

  return Array.from(dateMap.entries()).map(([date, shiftMap]) => {
    const shiftGroups = Array.from(shiftMap.entries()).map(
      ([label, items]) => ({
        label,
        items,
      })
    );

    return { date, shiftGroups };
  });
});

function datepickerToUtcDateOnly(d: string | Date | null | undefined) {
  if (!d) return "";

  const date =
    typeof d === "string"
      ? DateTime.fromISO(d, { zone: "utc" })
      : DateTime.fromJSDate(d, { zone: "utc" });

  return date.setZone("America/New_York").toFormat("HH:mm:ss");
}

function datepickerToUtcDateOnlyWithoutTime(d: any) {
  return d
    ? DateTime.fromISO(d, {
        zone: "utc",
      })
        .setZone("America/New_York")
        .toFormat("MMM d, HH:mm")
    : "-";
}

let filterVersion = 0;

const fetchTasks = async (
  requestedPage: number,
  append: boolean,
  version: number
): Promise<boolean> => {
  const loadingRef = append ? isLoadingMore : tasksLoading;

  loadingRef.value = true;

  // Snapshot: each request keeps its own filter values.
  const filters = {
    ...taskStore.commonFilter,
    page: requestedPage,
    per_page: PAGE_SIZE,
  };

  try {
    const { data } = await taskService.getTasks(filters);

    // Ignore responses from an outdated filter version.
    if (version !== filterVersion) return false;

    const items: ITaskData[] = data.items ?? [];

    tasks.value = append ? [...tasks.value, ...items] : items;

    page.value = requestedPage;
    taskStore.commonFilter.page = requestedPage;

    hasMore.value =
      data.has_more !== undefined ? data.has_more : items.length === PAGE_SIZE;

    return true;
  } catch (err: any) {
    if (version === filterVersion) {
      pushNotification(
        err.response?.data?.detail || "Failed to load tasks",
        "error"
      );
    }

    return false;
  } finally {
    if (!append && version === filterVersion) {
      tasksLoading.value = false;
    }

    if (append) {
      isLoadingMore.value = false;
    }
  }
};

const resetAndFetch = async () => {
  const version = ++filterVersion;

  tasks.value = [];

  page.value = 1;
  hasMore.value = true;

  // Block infinite scroll while the first page loads.
  tasksLoading.value = true;

  await fetchTasks(1, false, version);
};

const loadMore = async () => {
  if (
    tasksLoading.value ||
    isLoadingMore.value ||
    searchTimer !== null ||
    !hasMore.value
  ) {
    return;
  }

  const version = filterVersion;
  const nextPage = page.value + 1;

  await fetchTasks(nextPage, true, version);
};

let companySearchVersion = 0;
let driverSearchVersion = 0;
let problemSearchVersion = 0;
let filterWorkTypeVersion = 0;

const fetchCompanyOptions = async (searchText = "") => {
  const version = ++companySearchVersion;

  try {
    const { data } = await companyService.getSimpleCompanies({
      ...companyStore.commonSimpleFilter,
      search: searchText.trim(),
      page: 1,
    });

    if (version !== companySearchVersion) return;

    companies.value = data.items ?? [];
  } catch (error) {
    if (version === companySearchVersion) {
      console.error("Failed to load companies", error);
    }
  }
};

const fetchDriverOptions = async (
  searchText = "",
  companyId = newTask.value.company_id
) => {
  const version = ++driverSearchVersion;

  if (!companyId || newTask.value.company_name) {
    drivers.value = [];
    return;
  }

  try {
    const { data } = await driverService.getSimpleDrivers({
      ...driverStore.commonSimpleFilter,
      search: searchText.trim(),
      company_id: companyId,
      page: 1,
    });

    if (
      version !== driverSearchVersion ||
      newTask.value.company_id !== companyId
    ) {
      return;
    }

    drivers.value = data.items ?? [];
  } catch (error) {
    if (version === driverSearchVersion) {
      console.error("Failed to load drivers", error);
    }
  }
};

const fetchProblemOptions = async (searchText = "") => {
  const version = ++problemSearchVersion;

  try {
    const { data } = await workTypeService.getWorkTypes({
      is_active: true,
      search: searchText.trim(),
    });

    if (version !== problemSearchVersion) return;

    problems.value = data;
  } catch (error) {
    if (version === problemSearchVersion) {
      console.error("Failed to load work types", error);
    }
  }
};

const getList = async () => {
  if (searchCompanyTimer) clearTimeout(searchCompanyTimer);
  if (searchDriverTimer) clearTimeout(searchDriverTimer);
  if (searchProblemTimer) clearTimeout(searchProblemTimer);
  if (searchFilterProblemTimer) clearTimeout(searchFilterProblemTimer);
  if (searchFilterUserTimer) clearTimeout(searchFilterUserTimer);

  searchCompanyTimer = null;
  searchDriverTimer = null;
  searchProblemTimer = null;
  searchFilterProblemTimer = null;

  companyStore.commonSimpleFilter.search = "";
  driverStore.commonSimpleFilter.search = "";
  workTypeStore.commonFilter.search = "";

  // Invalidate previous searches before reloading reference lists.
  companySearchVersion++;
  driverSearchVersion++;
  problemSearchVersion++;
  filterWorkTypeVersion++;

  const companyVersion = companySearchVersion;
  const problemVersion = problemSearchVersion;
  const filterVersionSnapshot = filterWorkTypeVersion;

  // Invalidate pending driver requests for previous companies.
  drivers.value = [];

  const [fetchedTeams, workTypesResponse, companiesResponse, fetchUsers] =
    await Promise.all([
      teamStore.getTeams(teamLoading),
      workTypeService.getWorkTypes({
        is_active: true,
        search: "",
      }),
      companyService.getSimpleCompanies({
        ...companyStore.commonSimpleFilter,
        search: "",
        page: 1,
      }),
      usersStore.getUsers(userLoading),
    ]);

  const fetchedWorkTypes = workTypesResponse.data as IWorkType[];
  const fetchedCompanies = companiesResponse.data;

  await resetAndFetch();

  teams.value = fetchedTeams;
  if (filterVersionSnapshot === filterWorkTypeVersion) {
    workTypes.value = fetchedWorkTypes;
  }

  if (companyVersion === companySearchVersion) {
    companies.value = fetchedCompanies.items;
  }

  if (problemVersion === problemSearchVersion) {
    problems.value = fetchedWorkTypes;
  }
  users.value = fetchUsers;

  newTask.value = {
    company_id: "",
    driver_id: "",
    work_type_id: "",
    priority: "",
    assignee_id: "",
  };
};

const nextStatus = async (item: ITaskData) => {
  if (item.status == "new") {
    const data = await taskStore.startTask(tasksLoading, item.id);
    if (data) {
      pushNotification("Successfully changed", "success");
      await getList();
    }
  } else if (item.status == "in_progress") {
    const data = await taskStore.doneTask(tasksLoading, item.id);
    if (data) {
      pushNotification("Successfully changed", "success");
      await getList();
    }
  }
};

const confirmStatus = async (item: ITaskData) => {
  if (item.status == "in_progress") {
    const data = await taskStore.doneTask(tasksLoading, item.id);
    if (data) {
      pushNotification("Successfully changed", "success");
      await getList();
    }
  }
};

const availableStatusItems = (item: ITaskData) => {
  let allStatus: any[] = [];

  if (
    usersStore.userProfile?.role == "admin" ||
    usersStore.userProfile?.role == "super_admin"
  ) {
    allStatus = (
      Object.keys({
        IN_PROGRESS: "in_progress",
        ON_HOLD: "on_hold",
        DONE: "done",
        CLOSED: "closed",
      }) as Array<keyof typeof TaskStatus>
    ).map((key) => ({
      value: TaskStatus[key],
      name: formatStatusLabel(key),
      color: STATUS_COLORS[TaskStatus[key]],
    }));
  } else {
    if (item.status == "new") {
      allStatus = (
        Object.keys({
          IN_PROGRESS: "in_progress",
          ON_HOLD: "on_hold",
          DONE: "done",
        }) as Array<keyof typeof TaskStatus>
      ).map((key) => ({
        value: TaskStatus[key],
        name: formatStatusLabel(key),
        color: STATUS_COLORS[TaskStatus[key]],
      }));
    } else if (item.status == "in_progress") {
      allStatus = (
        Object.keys({
          ON_HOLD: "on_hold",
          DONE: "done",
        }) as Array<keyof typeof TaskStatus>
      ).map((key) => ({
        value: TaskStatus[key],
        name: formatStatusLabel(key),
        color: STATUS_COLORS[TaskStatus[key]],
      }));
    } else if (item.status == "on_hold") {
      allStatus = (
        Object.keys({
          IN_PROGRESS: "in_progress",
          DONE: "done",
        }) as Array<keyof typeof TaskStatus>
      ).map((key) => ({
        value: TaskStatus[key],
        name: formatStatusLabel(key),
        color: STATUS_COLORS[TaskStatus[key]],
      }));
    } else if (item.status == "qa_failed") {
      if (
        usersStore.userProfile?.role == "admin" ||
        usersStore.userProfile?.role == "supervisor"
      ) {
        allStatus = (
          Object.keys({
            IN_PROGRESS: "in_progress",
            ON_HOLD: "on_hold",
            DONE: "done",
            CLOSED: "closed",
          }) as Array<keyof typeof TaskStatus>
        ).map((key) => ({
          value: TaskStatus[key],
          name: formatStatusLabel(key),
          color: STATUS_COLORS[TaskStatus[key]],
        }));
      } else {
        allStatus = (
          Object.keys({
            IN_PROGRESS: "in_progress",
            ON_HOLD: "on_hold",
            DONE: "done",
          }) as Array<keyof typeof TaskStatus>
        ).map((key) => ({
          value: TaskStatus[key],
          name: formatStatusLabel(key),
          color: STATUS_COLORS[TaskStatus[key]],
        }));
      }
    }
  }

  allStatus.push({
    value: "archive",
    name: "ARCHIVE",
    color: "",
  });

  return allStatus;
};

const selectStatus = async (item: ITaskData, status: IDropdown) => {
  if (item.status == "on_hold") {
    const data = await taskStore.resumeTask(tasksLoading, item.id);
    if (data) {
      if (status.value == "in_progress") {
        pushNotification("Successfully changed", "success");
        await getList();
      } else {
        const data = await taskStore.doneTask(tasksLoading, item.id);
        if (data) {
          pushNotification("Successfully changed", "success");
          await getList();
        }
      }
    }
  } else {
    if (status.value == "on_hold") {
      const data = await taskStore.holdTask(tasksLoading, item.id);
      if (data) {
        pushNotification("Successfully changed", "success");
        await getList();
      }
    } else if (status.value == "in_progress") {
      const data = await taskStore.startTask(tasksLoading, item.id);
      if (data) {
        pushNotification("Successfully changed", "success");
        await getList();
      }
    } else if (status.value == "done") {
      const data = await taskStore.doneTask(tasksLoading, item.id);
      if (data) {
        pushNotification("Successfully changed", "success");
        await getList();
      }
    } else if (status.value == "closed") {
      await taskStore.closeTask(tasksLoading, item.id, async (data: any) => {
        if (data) {
          pushNotification("Successfully changed", "success");
          await getList();
        }
      });
    } else if (status.value == "archive") {
      openArchiveModal(item);
    }
  }
};

const createNewTask = async () => {
  if (isSaving.value) return;
  if (
    !problems.value.length ||
    !newTask.value.company_id ||
    !newTask.value.driver_id ||
    !newTask.value.work_type_id
  ) {
    return;
  }

  isSaving.value = true;

  try {
    if (newTask.value.company_name) {
      newTask.value.company_id = "";
      delete newTask.value.company_id;
    } else {
      delete newTask.value.company_name;
    }

    if (newTask.value.driver_name) {
      newTask.value.driver_id = "";
      delete newTask.value.driver_id;
    } else {
      delete newTask.value.driver_name;
    }

    if (newTaskStatus.value == "new") {
      newTask.value.assignee_id = usersStore.userProfile?.id as string;
      await taskStore.createTask(tasksLoading, newTask.value, (data: any) => {
        if (data) {
          if (Object.keys(data).length) {
            pushNotification("Successfully added", "success");
            getList();
          }
        }
      });
    } else {
      let result: any = { ...newTask.value };
      result.description = description.value;
      delete result.assignee_id;
      await taskStore.createInformTask(tasksLoading, result, (data: any) => {
        if (data) {
          if (Object.keys(data).length) {
            pushNotification("Successfully added", "success");
            getList();
            newTaskStatus.value = "new";
            description.value = "";
          }
        }
      });
    }
  } finally {
    isSaving.value = false;
  }
};

const refreshTaskWorkTypes = async (taskId: string) => {
  try {
    const { data } = await taskService.getTaskById(taskId);

    const index = tasks.value.findIndex((task) => task.id === taskId);

    if (index === -1) return;

    const current = tasks.value[index];

    tasks.value[index] = {
      ...current,
      ...data,
      isEditingProblem: current.isEditingProblem,
      isEditingUser: current.isEditingUser,
    };
  } catch (err: any) {
    pushNotification(
      err.response?.data?.detail || "Failed to refresh task",
      "error"
    );
  }
};

const updateProblem = async (e: any, item: ITaskData) => {
  e.stopPropagation();
  if (!item.work_type_id) return;

  await taskStore.changeTaskWorkType(
    tasksLoading,
    item.id,
    { work_type_id: item.work_type_id },
    (data: any) => {
      if (data) {
        pushNotification("Successfully added", "success");
        getList();
      }
    }
  );
};

const formatToEdt = (date: any) => {
  if (!date) return "";

  return date.split("T")[1] == "11:00:00.000Z"
    ? DateTime.fromISO(date, { zone: "utc" })
        .setZone("America/New_York")
        .toFormat("LLL d")
    : DateTime.fromISO(date, { zone: "utc" })
        .setZone("America/New_York")
        .toFormat("LLL d, HH:mm ZZZZ");
};

const tooltipContent = (list: any[]) =>
  list
    ?.map((item) => `<p>${item.label} - ${formatToEdt(item.date)}</p>`)
    ?.join("");

const createItems = (type: string) => {
  let allStatus: any[];

  if (type == "new") {
    allStatus = (
      Object.keys({
        INFORM: "inform",
      }) as Array<keyof typeof TaskStatus>
    ).map((key) => ({
      value: TaskStatus[key],
      name: formatStatusLabel(key),
      color: STATUS_COLORS[TaskStatus[key]],
    }));
  } else {
    allStatus = (
      Object.keys({
        NEW: "new",
      }) as Array<keyof typeof TaskStatus>
    ).map((key) => ({
      value: TaskStatus[key],
      name: formatStatusLabel(key),
      color: STATUS_COLORS[TaskStatus[key]],
    }));
  }

  return allStatus;
};

const dropdownSelect = (e: any) => {
  if (e.value === "inform") {
    newModal.value = true;
    description.value = "";
  } else {
    newTaskStatus.value = "new";
  }
};

const saveModal = async () => {
  newTaskStatus.value = "inform";
  newModal.value = false;
  newTask.value.work_type_id = "26317c42-8a8e-4666-b78a-eca83fbf1701";
  await nextTick();
};

const editModal = () => {
  newModal.value = true;
};

function enterFirst() {
  const el = dropdown2.value?.[0];

  if (!el) return;
  el.focus();
}

const goLink = (e: any, item: any) => {
  e.stopPropagation();
  window.open(item.eld_link, "_blank")?.focus();
};

const enterSecond = async () => {
  const el = dropdown3.value?.[0];

  if (!el) return;
  el.focus();
};

const searchCompany = (val: string) => {
  companySearchVersion++;

  if (searchCompanyTimer) clearTimeout(searchCompanyTimer);

  searchCompanyTimer = setTimeout(() => {
    searchCompanyTimer = null;
    void fetchCompanyOptions(val);
  }, 300);
};

const searchDriver = (val: string) => {
  driverSearchVersion++;

  if (searchDriverTimer) clearTimeout(searchDriverTimer);

  searchDriverTimer = setTimeout(() => {
    searchDriverTimer = null;
    void fetchDriverOptions(val);
  }, 300);
};

const searchProblems = (val: string) => {
  problemSearchVersion++;

  if (searchProblemTimer) clearTimeout(searchProblemTimer);

  searchProblemTimer = setTimeout(() => {
    searchProblemTimer = null;
    void fetchProblemOptions(val);
  }, 300);
};

const searchFilterWorkType = (val: string) => {
  filterWorkTypeVersion++;

  if (searchFilterProblemTimer) {
    clearTimeout(searchFilterProblemTimer);
  }

  searchFilterProblemTimer = setTimeout(async () => {
    searchFilterProblemTimer = null;
    const version = ++filterWorkTypeVersion;

    try {
      const { data } = await workTypeService.getWorkTypes({
        is_active: true,
        search: val.trim(),
      });

      if (version !== filterWorkTypeVersion) return;

      workTypes.value = data;
    } catch (error) {
      if (version === filterWorkTypeVersion) {
        console.error("Failed to load work type filter", error);
      }
    }
  }, 300);
};

const searchFilterUser = (val: string) => {
  if (searchFilterUserTimer) clearTimeout(searchFilterUserTimer);
  searchFilterUserTimer = setTimeout(async () => {
    usersStore.commonFilter.q = val;
    const [fetchedUsers] = await Promise.all([
      usersStore.getUsers(userLoading),
    ]);

    users.value = fetchedUsers;
  });
};

const openArchiveModal = (item: ITaskData) => {
  archiveModal.value = true;
  archiveReason.value = "";
  archiveModalItem.value = item;
};

const closeArchiveModal = () => {
  archiveModal.value = false;
  archiveReason.value = "";
  archiveModalItem.value = null;
};

const saveArchive = async () => {
  if (!archiveReason.value) return;
  if (!archiveModalItem.value) return;

  await archiveStore.archiveTask(
    tasksLoading,
    archiveModalItem.value.id,
    archiveReason.value,
    async (data: any) => {
      if (data) {
        pushNotification("Successfully archived", "success");
        closeArchiveModal();
        await getList();
      }
    }
  );
};

const rowClick = async (item: any, index: number) => {
  if (usersStore.userProfile?.role === "super_admin") {
    await taskStore.getTaskTimeline(taskModalLoading, item.id, (res: any) => {
      if (res) {
        taskModal.value = true;
        let comments: any[] = [];
        taskModalItem.value = res.data;
        if (taskModalItem.value.items && taskModalItem.value.items.length) {
          comments = taskModalItem.value.items.filter(
            (item: any) => item.event_type === "comment"
          );
          taskModalItem.value.items = taskModalItem.value.items.filter(
            (item: any) => item.event_type !== "comment"
          );
        }
        taskModalItem.value.comments = comments;
        taskModalItem.value.rest_short_info = item.rest_short_info;
      }
    });
  }
};

const displayDropdownItem = (name: string) => {
  const labels: any = {
    new: "New",
    inform: "Inform",
    in_progress: "In Progress",
    on_hold: "On Hold",
    done: "Done",
    qa_failed: "Qa Failed",
    closed: "Closed",
  };

  return labels[name];
};

const openEditingProblem = (e: any, item: any, type: boolean) => {
  e.stopPropagation();
  item.isEditingProblem = type;
};

// Reassign user

const assignSuggestions = ref<any[]>([]);

const openEditingUser = (e: any, item: any, type: boolean) => {
  e.stopPropagation();

  if (type) {
    taskStore.getReassignSuggestions(tasksLoading, item.id, (res: any) => {
      if (res.data.candidates && res.data.candidates.length) {
        assignSuggestions.value = res.data.candidates;
      } else {
        pushNotification("No free specialists", "error");
      }
    });
  }
  item.isEditingUser = type;
};

const reassignUser = async (e: any, item: any) => {
  e.stopPropagation();
  if (!item.reassignedUser) return;

  await taskStore.reassignTask(
    tasksLoading,
    item.id,
    {
      assignee_id: item.reassignedUser,
    },
    (res: any) => {
      if (res) {
        pushNotification("Successfully changed", "success");
        getList();
      }
    }
  );
};

// Adding comment

const addTaskModalComment = async () => {
  if (!taskModalItem.value || !taskModalComment.value) return;

  await taskStore.addComment(
    taskModalLoading,
    taskModalItem.value.task_id,
    { text: taskModalComment.value },
    (data: any) => {
      if (data) {
        pushNotification("Successfully added", "success");
        closeTaskModal();
        getList();
      }
    }
  );
};

const closeTaskModal = () => {
  taskModalItem.value = undefined;
  taskModal.value = false;
  taskModalComment.value = "";
};

const copyRestInfo = async (item: string) => {
  await navigator.clipboard.writeText(item);
  pushNotification("Successfully copied", "success");
};

const copyAllInfo = async () => {
  let result = "";

  Object.keys(taskModalItem.value.rest_short_info.items).forEach(
    (item: any) => {
      if (
        taskModalItem.value.rest_short_info.items[item] &&
        taskModalItem.value.rest_short_info.items[item].copyContent
      ) {
        result += taskModalItem.value.rest_short_info.items[item].copyContent;
      }
    }
  );
  await navigator.clipboard.writeText(result);
  pushNotification("Successfully copied", "success");
};

const isChecking = ref<boolean>(false);
const uid = ref("");
const selectedRecords = ref<any[]>([]);

const selectedModel = computed({
  get() {
    return selectedRecords.value;
  },
  set(value) {
    selectedRecords.value = value;
  },
});

const isSelected = (item: any) => {
  return selectedModel.value.some((row: any) => row === item.id);
};

const goToCheck = () => {
  isChecking.value = true;
};

const saveCheck = async () => {
  if (!selectedModel.value.length) return;
  const organizationId: string = localStorage.getItem(
    "organizationId"
  ) as string;
  if (!organizationId) router.push("/organization");
  await checkStore.createManualSelection(
    tasksLoading,
    {
      organization_id: organizationId,
      task_ids: selectedModel.value,
    },
    (res: unknown) => {
      if (res) {
        pushNotification("Successfully created", "success");
        isChecking.value = false;
      }
    }
  );
};

onMounted(async () => {
  companyStore.commonSimpleFilter.search = "";
  companyStore.commonSimpleFilter.per_page = 50;
  driverStore.commonSimpleFilter.search = "";
  workTypeStore.commonFilter.search = "";

  if (usersStore.userProfile?.role === "admin") {
    isAdmin.value = true;
  }

  if (taskStore.commonFilter.search) {
    search.value = taskStore.commonFilter.search;
  }

  if (taskStore.commonFilter.team_id) {
    team.value = taskStore.commonFilter.team_id;
  } else {
    if (usersStore.userProfile && usersStore.userProfile.team_id) {
      team.value = usersStore.userProfile.team_id;
      companyStore.commonSimpleFilter.team_id = usersStore.userProfile.team_id;
      taskStore.commonFilter.team_id = usersStore.userProfile.team_id;
    }
  }

  if (taskStore.commonFilter.status) {
    status.value = taskStore.commonFilter.status;
  }

  if (taskStore.commonFilter.work_type_id) {
    problem.value = taskStore.commonFilter.work_type_id;
  }
  await getList();

  observer = new IntersectionObserver(
    (entries) => {
      if (entries[0]?.isIntersecting) loadMore();
    },
    { root: scrollContainer.value, rootMargin: "200px" }
  );
  if (sentinel.value) observer.observe(sentinel.value);

  await nextTick();
  dropdown1.value?.[0]?.focus();
});

onBeforeMount(() => {
  uid.value = crypto.randomUUID();
});

watch(search, (val) => {
  taskStore.commonFilter.search = val;

  // Invalidate all previous requests immediately.
  filterVersion++;

  if (searchTimer) clearTimeout(searchTimer);

  searchTimer = setTimeout(() => {
    searchTimer = null;
    void resetAndFetch();
  }, 300);
});

watch(team, (val: string) => {
  taskStore.commonFilter.team_id = val;
  void resetAndFetch();
});

watch(user, (val: string) => {
  taskStore.commonFilter.assignee_id = val;
  void resetAndFetch();
});

watch(status, (val: string) => {
  taskStore.commonFilter.status = val;
  void resetAndFetch();
});

watch(problem, (val: string) => {
  taskStore.commonFilter.work_type_id = val;
  void resetAndFetch();
});

watch(
  () => newTask.value.company_id,
  async (val) => {
    driverSearchVersion++;

    if (searchDriverTimer) {
      clearTimeout(searchDriverTimer);
      searchDriverTimer = null;
    }

    driverStore.commonSimpleFilter.search = "";

    const newVal = companies.value.some(
      (item) => item.id.toLowerCase() === val
    );
    drivers.value = [];
    newTask.value.driver_id = "";
    newTask.value.work_type_id = "";

    if (!newVal) {
      if (val) {
        newTask.value.company_name = val;
      } else {
        delete newTask.value.company_name;
      }

      driverStore.commonSimpleFilter.company_id = "";
      drivers.value = [];
    } else {
      delete newTask.value.company_name;

      if (val) {
        driverStore.commonSimpleFilter.company_id = val;
        await fetchDriverOptions("", val);
      }
    }
  }
);

watch(
  () => newTask.value.driver_id,
  (val) => {
    const newVal = drivers.value.some((item) => item.id.toLowerCase() === val);

    if (!newVal) {
      newTask.value.driver_name = val;
    }
  }
);

watch(
  () => appStore.refreshKey,
  () => {
    getList();
  },
  {
    immediate: false,
  }
);

onUnmounted(() => {
  if (searchTimer) {
    clearTimeout(searchTimer);
    searchTimer = null;
  }
  filterVersion++;
  companySearchVersion++;
  driverSearchVersion++;
  problemSearchVersion++;
  filterWorkTypeVersion++;
  observer?.disconnect();
  taskStore.clearCommonFilter();
  companyStore.clearSimpleFilter();
  driverStore.clearCommonSimpleFilter();
  workTypeStore.clearFilter();
  usersStore.clearFilter();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CommonSearch, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        icon: _unref(SearchMd),
        placeholder: 'Search',
        clearable: ""
      }, null, 8, ["modelValue", "icon"]),
      _createVNode(CommonDropdown, {
        modelValue: team.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((team).value = $event)),
        items: teams.value.map((t) => ({ value: t.id, name: t.name })),
        label: "Team",
        position: "bottom",
        dropdownFullWidth: "",
        clearable: ""
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CustomSearchDropdown, {
        modelValue: user.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user).value = $event)),
        items: userFilterItems.value,
        label: "User",
        position: "bottom",
        clearable: "",
        dropdownFullWidth: "",
        maxWidth: "200px",
        onSearch: searchFilterUser
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CommonDropdown, {
        modelValue: status.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((status).value = $event)),
        items: _unref(statusItems),
        label: "Status",
        position: "bottom",
        clearable: ""
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CustomSearchDropdown, {
        modelValue: problem.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((problem).value = $event)),
        items: problemFilterItems.value,
        label: "Problem",
        position: "bottom",
        clearable: "",
        dropdownFullWidth: "",
        maxWidth: "400px",
        onSearch: searchFilterWorkType
      }, null, 8, ["modelValue", "items"]),
      (
          _unref(usersStore).userProfile?.role == 'super_admin' ||
          _unref(usersStore).userProfile?.role == 'admin' ||
          _unref(usersStore).userProfile?.role == 'supervisor'
        )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (isChecking.value)
              ? (_openBlock(), _createBlock(CommonButton, {
                  key: 0,
                  type: "primary",
                  label: `Go to check (${selectedModel.value.length})`,
                  loading: tasksLoading.value,
                  isDisabled: tasksLoading.value,
                  onClicked: saveCheck
                }, null, 8, ["label", "loading", "isDisabled"]))
              : (_openBlock(), _createBlock(CommonButton, {
                  key: 1,
                  style: {"border-color":"var(--color-primary)"},
                  type: "outline-primary",
                  label: "Check",
                  onClicked: goToCheck
                }))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByDate.value, (dateGroup, dateIndex) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: dateIndex }, [
          _createElementVNode("div", {
            class: _normalizeClass(["v-tasks__date-row", { 'is-collapsed': isDateCollapsed(dateGroup.date) }]),
            onClick: ($event: any) => (toggleDate(dateGroup.date))
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(dateGroup.date), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["v-tasks__date-chevron", { 'is-collapsed': isDateCollapsed(dateGroup.date) }])
            }, [
              _createVNode(_unref(ChevronDown), { size: 20 })
            ], 2)
          ], 10, _hoisted_4),
          (!isDateCollapsed(dateGroup.date))
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(dateGroup.shiftGroups, (shiftGroup, shiftIndex) => {
                return (_openBlock(), _createBlock(CommonTable, {
                  key: shiftIndex,
                  headers: filteredItems.value,
                  groups: [{ label: shiftGroup.label, items: shiftGroup.items }],
                  loading: tasksLoading.value,
                  collapsed: isShiftCollapsed(dateGroup.date, shiftGroup.label),
                  onToggleGroup: ($event: any) => (toggleShift(dateGroup.date, shiftGroup.label)),
                  isTaskTable: "",
                  dateIndex: dateIndex,
                  shiftIndex: shiftIndex,
                  isAdmin: isAdmin.value,
                  withoutHeader: shiftIndex > 0,
                  onRowClick: rowClick
                }, _createSlots({
                  id: _withCtx(({ item, index }) => [
                    (isChecking.value)
                      ? (_openBlock(), _createElementBlock("label", {
                          key: 0,
                          class: _normalizeClass(["custom__checkbox", isSelected(item) ? 'active' : '']),
                          onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedModel).value = $event)),
                            value: item.id,
                            class: "ui-checkbox form-checkbox",
                            type: "checkbox",
                            name: uid.value
                          }, null, 8, _hoisted_6), [
                            [_vModelCheckbox, selectedModel.value]
                          ]),
                          _createVNode(_unref(Check), { size: 14 })
                        ], 2))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(index + 1), 1))
                  ]),
                  company: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _createTextVNode(_toDisplayString(item.company_name) + " ", 1),
                        (item.company_note)
                          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_10, [
                              _createVNode(_unref(InfoCircle), { size: 14 })
                            ])), [
                              [_directive_tooltip, {
                        content: item.company_note,
                        html: true,
                      }]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(item.provider_name?.split(" ")[0] || "Hos"), 1)
                    ])
                  ]),
                  drivers: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_12, [
                      _createTextVNode(_toDisplayString(item.driver_name) + " ", 1),
                      (item.driver_note)
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createVNode(_unref(InfoCircle), { size: 14 })
                          ])), [
                            [_directive_tooltip, {
                      content: item.driver_note,
                      html: true,
                    }]
                          ])
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  team: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(item.team_name), 1)
                  ]),
                  users: _withCtx(({ item }) => [
                    (!item.isEditingUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(item.assignee_name), 1),
                          (
                      (_unref(usersStore).userProfile?.role === 'super_admin' ||
                        _unref(usersStore).userProfile?.role === 'admin' ||
                        _unref(usersStore).userProfile?.role === 'supervisor') &&
                      item.status == 'in_progress'
                    )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "edit",
                                onClick: (e) => openEditingUser(e, item, true)
                              }, [
                                _createVNode(_unref(Pencil02), { size: 16 })
                              ], 8, _hoisted_17))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(CustomTableDropdown, {
                            modelValue: item.reassignedUser,
                            "onUpdate:modelValue": ($event: any) => ((item.reassignedUser) = $event),
                            items: 
                                      assignSuggestions.value.map((p) => ({
                                        value: p.id,
                                        name: p.name,
                                      }))
                                    ,
                            label: "User",
                            position: "bottom",
                            maxWidth: "100%",
                            dropdownFullWidth: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                          _createElementVNode("div", {
                            class: "clear",
                            onClick: (e) => openEditingUser(e, item, false)
                          }, [
                            _createVNode(_unref(X), { size: 16 })
                          ], 8, _hoisted_19),
                          _createElementVNode("div", {
                            class: _normalizeClass(["problem__save", !item.work_type_id ? 'disabled' : '']),
                            onClick: (e) => reassignUser(e, item)
                          }, " Save ", 10, _hoisted_20)
                        ]))
                  ]),
                  date: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(datepickerToUtcDateOnly(item.created_time)), 1)
                  ]),
                  completed_time: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(datepickerToUtcDateOnly(item.completed_time) || "-"), 1)
                  ]),
                  status: _withCtx(({ item }) => [
                    (item.status && getStatus(item.status))
                      ? (_openBlock(), _createBlock(CommonStatus, {
                          key: 0,
                          status: getStatus(item.status)!,
                          onNext: ($event: any) => (nextStatus(item)),
                          onConfirm: ($event: any) => (confirmStatus(item)),
                          onSelected: (e) => selectStatus(item, e),
                          showActions: hasUserHasAction(item),
                          items: availableStatusItems(item),
                          tooltipContent: 
                    tooltipContent(item.qa_failed_reason_details)
                  
                        }, null, 8, ["status", "onNext", "onConfirm", "onSelected", "showActions", "items", "tooltipContent"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, "—"))
                  ]),
                  problems: _withCtx(({ item }) => [
                    (!item.isEditingProblem)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(item.description || item.work_type_name), 1),
                          (
                      hasUserHasAction(item) &&
                      item.status == 'in_progress' &&
                      item.source !== 'eld_import'
                    )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "edit",
                                onClick: (e) => openEditingProblem(e, item, true)
                              }, [
                                _createVNode(_unref(Pencil02), { size: 16 })
                              ], 8, _hoisted_24))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createVNode(CustomTableDropdown, {
                            modelValue: item.work_type_id,
                            "onUpdate:modelValue": ($event: any) => ((item.work_type_id) = $event),
                            items: 
                                      problems.value.map((p) => ({
                                        value: p.id,
                                        name: p.name,
                                      }))
                                    ,
                            label: "Problem",
                            position: "bottom",
                            maxWidth: "100%",
                            dropdownFullWidth: "",
                            onSearch: searchProblems
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                          _createElementVNode("div", {
                            class: "clear",
                            onClick: (e) => openEditingProblem(e, item, false)
                          }, [
                            _createVNode(_unref(X), { size: 16 })
                          ], 8, _hoisted_26),
                          _createElementVNode("div", {
                            class: _normalizeClass(["problem__save", !item.work_type_id ? 'disabled' : '']),
                            onClick: (e) => updateProblem(e, item)
                          }, " Save ", 10, _hoisted_27)
                        ])),
                    _createVNode(TaskAdditionalWorkTypes, {
                      task: item,
                      "work-types": workTypes.value,
                      "can-edit": Boolean(hasUserHasAction(item)),
                      onUpdated: ($event: any) => (refreshTaskWorkTypes(item.id))
                    }, null, 8, ["task", "work-types", "can-edit", "onUpdated"])
                  ]),
                  actions: _withCtx(({ item }) => [
                    (item.eld_link)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(_unref(LinkExternal02), {
                            size: 16,
                            onClick: (e) => goLink(e, item)
                          }, null, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, [
                  (!isChecking.value)
                    ? {
                        name: "new-row",
                        fn: _withCtx(() => [
                          _cache[26] || (_cache[26] = _createElementVNode("td", null, null, -1)),
                          _createElementVNode("td", _hoisted_29, [
                            _createVNode(CustomTableDropdown, {
                              ref_for: true,
                              ref_key: "dropdown1",
                              ref: dropdown1,
                              modelValue: newTask.value.company_id,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newTask.value.company_id) = $event)),
                              items: companyItems.value,
                              label: "Company",
                              position: "bottom",
                              clearable: "",
                              maxWidth: "100%",
                              dropdownFullWidth: "",
                              isAppendItem: "",
                              onEnter: enterFirst,
                              creatable: "",
                              onSearch: searchCompany
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _createElementVNode("td", _hoisted_30, [
                            _createVNode(CustomTableDropdown, {
                              ref_for: true,
                              ref_key: "dropdown2",
                              ref: dropdown2,
                              modelValue: newTask.value.driver_id,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newTask.value.driver_id) = $event)),
                              items: driverItems.value,
                              label: "Driver",
                              position: "bottom",
                              clearable: "",
                              dropdownFullWidth: "",
                              maxWidth: "100%",
                              isAppendItem: "",
                              onEnter: enterSecond,
                              creatable: "",
                              onSearch: searchDriver
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          (!_unref(taskStore).commonFilter.team_id)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_31, _toDisplayString(_unref(usersStore).userProfile?.team_name), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, _toDisplayString(_unref(usersStore).userProfile?.name), 1),
                          _createElementVNode("td", null, _toDisplayString(datepickerToUtcDateOnly(new Date())), 1),
                          _cache[27] || (_cache[27] = _createElementVNode("td", null, "-", -1)),
                          _cache[28] || (_cache[28] = _createElementVNode("td", null, "-", -1)),
                          _createElementVNode("td", null, [
                            _createVNode(CommonStatus, {
                              status: getStatus(newTaskStatus.value),
                              onNext: _cache[10] || (_cache[10] = ($event: any) => (console.log('Next driver-status'))),
                              onConfirm: _cache[11] || (_cache[11] = ($event: any) => (console.log('Confirm driver-status'))),
                              items: createItems(newTaskStatus.value),
                              onSelected: dropdownSelect,
                              arrow: false,
                              showActions: ""
                            }, null, 8, ["status", "items"])
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(CustomTableDropdown, {
                                ref_for: true,
                                ref_key: "dropdown3",
                                ref: dropdown3,
                                modelValue: newTask.value.work_type_id,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((newTask.value.work_type_id) = $event)),
                                items: problemItems.value,
                                label: "Problem",
                                position: "bottom",
                                clearable: "",
                                dropdownFullWidth: "",
                                isAppendItem: "",
                                onEnter: createNewTask,
                                onSearch: searchProblems
                              }, null, 8, ["modelValue", "items"]),
                              (newTaskStatus.value == 'inform')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "problem__group--edit",
                                    onClick: editModal
                                  }, [
                                    _createVNode(_unref(Pencil02), { size: 16 })
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: _normalizeClass(["problem__group--save", 
                        isSaving.value ||
                        !problems.value.length ||
                        !newTask.value.company_id ||
                        !newTask.value.driver_id ||
                        !newTask.value.work_type_id
                          ? 'disabled'
                          : ''
                      ]),
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (!isSaving.value && createNewTask()))
                              }, " Save ", 2)
                            ])
                          ])
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["headers", "groups", "loading", "collapsed", "onToggleGroup", "dateIndex", "shiftIndex", "isAdmin", "withoutHeader"]))
              }), 128))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createElementVNode("div", {
        ref_key: "sentinel",
        ref: sentinel,
        class: "v-tasks__sentinel"
      }, null, 512),
      (isLoadingMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Loading more… "))
        : (!hasMore.value && tasks.value.length && !tasksLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, " No more tasks "))
          : _createCommentVNode("", true)
    ]),
    _createVNode(CommonModal, {
      modelValue: newModal.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((newModal).value = $event)),
      title: "Description"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: _cache[15] || (_cache[15] = ($event: any) => (newModal.value = false))
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveModal
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(CommonSearch, {
            modelValue: description.value,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((description).value = $event)),
            placeholder: "Type here ...",
            width: "100%"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonModal, {
      modelValue: archiveModal.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((archiveModal).value = $event)),
      title: "Archive reason"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: closeArchiveModal
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveArchive
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(CommonInput, {
            modelValue: archiveReason.value,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((archiveReason).value = $event)),
            label: "Reason",
            multiline: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (archiveReason.value = 'Duplicate task'))
          }, " Duplicate task "),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (archiveReason.value = 'Wrong name'))
          }, "Wrong name"),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (archiveReason.value = 'Need to change status'))
          }, " Need to change status "),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (archiveReason.value = 'Another worker doing'))
          }, " Another worker doing "),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (archiveReason.value = 'Created by mistake'))
          }, " Created by mistake ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonModal, {
      width: "1200px",
      modelValue: taskModal.value,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((taskModal).value = $event)),
      title: "Task details"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "headline" }, "History", -1)),
            _createElementVNode("table", null, [
              _cache[29] || (_cache[29] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "User"),
                  _createElementVNode("th", null, "Status"),
                  _createElementVNode("th", null, "Changed by"),
                  _createElementVNode("th", null, "Date")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskModalItem.value.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      (item.event_type == 'reassigned')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("span", _hoisted_44, _toDisplayString(item.old_value?.assignee_name
                          ? item.old_value?.assignee_name
                          : "-"), 1),
                            _createElementVNode("span", _hoisted_45, [
                              _createVNode(_unref(ArrowNarrowRight), { size: 20 })
                            ]),
                            _createElementVNode("span", _hoisted_46, _toDisplayString(item.new_value?.assignee_name
                          ? item.new_value.assignee_name
                          : "-"), 1)
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(item.changed_by_name), 1)
                          ], 64))
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_47, [
                        (item.old_value?.status !== item.new_value?.status)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge", item.old_value?.status])
                              }, _toDisplayString(item.old_value?.status
                          ? displayDropdownItem(item.old_value?.status)
                          : "-"), 3),
                              _createElementVNode("span", _hoisted_48, [
                                _createVNode(_unref(ArrowNarrowRight), { size: 20 })
                              ]),
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge", item.new_value?.status])
                              }, _toDisplayString(item.new_value?.status
                          ? displayDropdownItem(item.new_value.status)
                          : "-"), 3)
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass(["badge", item.new_value?.status])
                            }, _toDisplayString(item.new_value?.status
                          ? displayDropdownItem(item.new_value.status)
                          : "-"), 3))
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.changed_by_name), 1),
                    _createElementVNode("td", null, _toDisplayString(datepickerToUtcDateOnlyWithoutTime(item.created_time)), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "headline" }, "Comment", -1)),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                (taskModalItem.value.comments && taskModalItem.value.comments.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskModalItem.value.comments, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "item",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_53, _toDisplayString(datepickerToUtcDateOnlyWithoutTime(item.created_time)), 1),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, _toDisplayString(item.changed_by_name), 1),
                            _createElementVNode("div", _hoisted_56, _toDisplayString(item.comment), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_57, "No comments"))
              ]),
              _createElementVNode("div", _hoisted_58, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((taskModalComment).value = $event)),
                  type: "text",
                  placeholder: "Write a comment ..."
                }, null, 512), [
                  [_vModelText, taskModalComment.value]
                ]),
                _createElementVNode("div", {
                  class: "icon",
                  onClick: addTaskModalComment
                }, [
                  _createVNode(_unref(Send03), { size: 16 })
                ])
              ])
            ])
          ])
        ]),
        (
          taskModalItem.value.rest_short_info &&
          Object.keys(taskModalItem.value.rest_short_info.items).length
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "caption" }, "Rest info", -1)),
                _createElementVNode("div", {
                  class: "icon",
                  onClick: copyAllInfo
                }, [
                  _createVNode(_unref(Copy06), { size: 16 })
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(
              taskModalItem.value.rest_short_info.items
            ), (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (taskModalItem.value.rest_short_info.items[item])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, _toDisplayString(taskModalItem.value.rest_short_info.items[item].title), 1),
                            (taskModalItem.value.rest_short_info.items[item].copyContent)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "icon",
                                  onClick: ($event: any) => (
                    copyRestInfo(
                      taskModalItem.value.rest_short_info.items[item].copyContent
                    )
                  )
                                }, [
                                  _createVNode(_unref(Copy06), { size: 16 })
                                ], 8, _hoisted_65))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "title" }, "Duration:", -1)),
                              _createElementVNode("div", _hoisted_68, _toDisplayString(taskModalItem.value.rest_short_info.items[item]
                        .durationSeconds || "-"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _cache[34] || (_cache[34] = _createElementVNode("div", { class: "title" }, "From:", -1)),
                              _createElementVNode("div", _hoisted_70, _toDisplayString(taskModalItem.value.rest_short_info.items[item].time?.utc
                        .displayFrom
                        ? taskModalItem.value.rest_short_info.items[
                            item
                          ].time?.utc.displayFrom.split(" UTC")[0]
                        : "-"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "title" }, "To:", -1)),
                              _createElementVNode("div", _hoisted_72, _toDisplayString(taskModalItem.value.rest_short_info.items[item].time?.utc
                        .displayTo
                        ? taskModalItem.value.rest_short_info.items[
                            item
                          ].time?.utc.displayTo.split(" UTC")[0]
                        : "-"), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _cache[36] || (_cache[36] = _createElementVNode("div", { class: "title" }, "Location:", -1)),
                              _createElementVNode("div", _hoisted_75, _toDisplayString(taskModalItem.value.rest_short_info.items[item].location?.raw ||
                      "-"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              _cache[37] || (_cache[37] = _createElementVNode("div", { class: "title" }, "Status", -1)),
                              _createElementVNode("div", _hoisted_77, [
                                (taskModalItem.value.rest_short_info.items[item].status)
                                  ? (_openBlock(), _createBlock(CustomStatusBadge, {
                                      key: 0,
                                      label: taskModalItem.value.rest_short_info.items[item].status
                                    }, null, 8, ["label"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_78, "-"))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})